import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/intro.mp4")